export default "__VITE_ASSET__f78d6ad8__"